import { useCallback, useState } from 'react';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { DragAndDrop } from './components/DragAndDrop';
import { GalleryArea } from './components/GalleryArea';
import { GenerateButton } from './components/GenerateButton';
import { UploadedImage } from './components/UploadedImage';
import { UrlInput } from './components/UrlInput';
import { useFetchAIGeneratedMotion } from './hooks/useFetchAIGeneratedMotion';
import styles from './imageToMotionSubTab.module.scss';

export const ImageToMotionSubTab = ({ onSelectMedia }) => {
    const { accountName } = useAccount();
    const [imageData, setImageData] = useState(null);
    const [videos, setVideos] = useState([]);
    const imageDataUrl = imageData?.value;

    const {
        error,
        isFetching,
        refetch: fetchAIGeneratedMotion,
    } = useFetchAIGeneratedMotion({
        imageUrl: imageDataUrl,
        accountId: accountName,
        isRegenerated: videos.length > 0,
        setVideos,
    });

    const onGenerateClick = async () => {
        if (!imageDataUrl || !accountName) {
            return;
        }
        await fetchAIGeneratedMotion();
    };

    const onCleanMedia = useCallback(() => {
        setImageData(null);
        setVideos([]);
    }, [setImageData, setVideos]);

    const UploadedImageSection = (
        <>
            <UploadedImage imageDataUrl={imageDataUrl} onCleanMedia={onCleanMedia} />
            <GenerateButton
                onGenerateClick={onGenerateClick}
                isLoading={isFetching}
                isGalleryDisplayed={videos?.length > 0}
            />
        </>
    );
    const InputSection = (
        <>
            <DragAndDrop setImageData={setImageData} />
            <UrlInput setImageData={setImageData} />
        </>
    );
    return (
        <div className={styles['image-to-motion-sub-tab']}>
            {imageDataUrl ? UploadedImageSection : InputSection}
            <GalleryArea
                isLoading={isFetching}
                shouldShowError={!!error}
                videos={videos}
                onSelectMedia={onSelectMedia}
            />
        </div>
    );
};
